export const LABELS = {
  title: 'Oops! Something went wrong.',
  buttonText: 'Try logging in again?',
  loading: 'Loading...',
  noAssessmnetData: 'Please fill the assessment form to get the analysis.',
};
